import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';

interface SelectedDMState {
  selectedDmId: string | null;
  setSelectedDmId: (dmId: string | null) => void;
}

const SelectedDMContext = createContext<SelectedDMState | null>(null);

export function SelectedDMProvider({ children }: { children: ReactNode }) {
  const [selectedDmId, setSelectedDmId] = useState<string | null>(null);
  return (
    <SelectedDMContext.Provider value={{ selectedDmId, setSelectedDmId }}>
      {children}
    </SelectedDMContext.Provider>
  );
}

export function useSelectedDM(): SelectedDMState {
  const ctx = useContext(SelectedDMContext);
  if (!ctx) throw new Error('useSelectedDM must be used inside <SelectedDMProvider>');
  return ctx;
}
